//!#system	

<template>
	<div>
		<v-card v-if="isLoading" flat>
			<v-progress-linear :indeterminate="true"></v-progress-linear>
		</v-card>
		<v-card v-if="isLoaded">
			<v-card-title>
				<span class="headline">Queue Buckets</span>
			</v-card-title>
			<v-card-text>
				Choose the buckets that you want to use the queue with.
				<div style="margin-bottom: 20px"></div>
				<v-progress-linear v-if="isDoingSomething" :indeterminate="true"></v-progress-linear>
				<div>
					<span v-for="availableTag in availableTags" :key="availableTag.tag">
						<v-chip v-if="currentTags.includes(availableTag.tag)" class="mr-1 mb-1" color="primary" close @click:close="deTagIt(availableTag.tag)">
							<v-icon left small>mdi-checkbox-marked</v-icon>
							{{ availableTag.tag }}
						</v-chip>
						<v-chip v-else class="mr-1 mb-1" @click="tagIt(availableTag.tag)">
							{{ availableTag.tag }}
						</v-chip>
					</span>
				</div>
				<div style="margin-bottom: 20px"></div>
				<v-alert type="info" dense text>
					<span style="font-size: 13px;">Don't see the bucket you're looking for? Create it as an available tag first (these buckets are just tags on this queue).</span>
				</v-alert>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary" @click="closeDialog()">Done</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>
import apiService from '@/apiService';
import series from 'to-series';
export default {
	name: 'QueueTagging',
	props: {
		routeInfo: {
			type: Object,
			default: () => { return {} }
		}
	},
	data() {
		return {
			isLoading: false,
			isDoingSomething: false,
			availableTags: [],
			currentTags: []
		};
	},
	computed: {
		isLoaded() {
			return !this.isLoading;
		}
	},
	methods: {
		getInitialData() {
			this.isLoading = true;
			series()
				.first(this.getAvailableTags)
				.next(this.getCurrentTags)
				.end(err => {
					if (err) {
						this.$store.dispatch('app/applyObjectError', {
							show: true,
							text: err
						});
					}
					this.isLoading = false;
				});
		},
		getAvailableTags(done) {
			apiService.availableTags(this.routeInfo, (err, tags) => {
				if (err) return done(err);
				this.availableTags = tags;
				return done();
			});
		},
		getCurrentTags(done) {
			apiService.detail(this.routeInfo, (err, response) => {
				if (err) return done(err);
				if (response.tags) {
					this.currentTags = response.tags;
				}
				return done();
			});
		},
		tagIt(tagStr) {
			this.isDoingSomething = true;
			apiService.tag({
				...this.routeInfo,
				body: { tag: tagStr }
			}, (err, response) => {
				if (err) {
					this.$store.dispatch('app/applyObjectError', {
						show: true,
						text: err
					});
				}
				this.getCurrentTags(() => {
					this.isDoingSomething = false;
				});
			});
		},
		deTagIt(tagStr) {
			this.isDoingSomething = true;
			apiService.untag({
				...this.routeInfo,
				body: { tag: tagStr }
			}, (err, response) => {
				if (err) {
					this.$store.dispatch('app/applyObjectError', {
						show: true,
						text: err
					});
				}
				this.getCurrentTags(() => {
					this.isDoingSomething = false;
				});
			});
		},
		closeDialog() {
			this.$emit('refresh');
			this.$emit('close');
		},
	},
	created() {
		this.getInitialData();
	}
}
</script>